import { I18n } from "@assets/strings";
import React from "react";
import { useHistory } from "@core/routing/useHistory";
import styled from "styled-components";
import { Path } from "@core/routing/path";
import { useServices } from "@core/servicesContext";
import { Quiz } from "@domain/lms/quiz/quiz";
import { useAsync } from "@utils/hooks";
import { LoadingButton } from "@ui/components/buttons/loadingButton";
import { Primary } from "@ui/components/containers/primary";
import { Title } from "@ui/components/containers/title";
import { Stack, stack } from "@ui/components/layout";
import { QuizResultIcon } from "./quizResultIcon";

interface QuizEndingProps extends React.HTMLAttributes<HTMLDivElement> {
	quiz: Quiz;
	isAuthor?: boolean;
}
export const QuizEnding: React.FC<QuizEndingProps> = ({ quiz, isAuthor, ...htmlProps }) => {
	const score = isAuthor ? quiz.participantDetails.score : quiz.participants.score;
	const { participantDetails } = quiz;

	const { quizService, postService } = useServices();
	const history = useHistory();
	const { run, loading } = useAsync(async () => {
		await quizService.shareQuizResult(quiz.id);
		history.push(Path.Root);
		postService.fetchFeed();
	}, [quiz]);

	return (
		<Container {...htmlProps}>
			<Title>{I18n.t("quiz.finished.title")}</Title>
			<QuizResultIcon score={score} />
			<Stack gap={16}>
				<ScoreDescription>
					<span>
						<span>
							{isAuthor
								? I18n.t("quiz.finished.score.particpant", {
										name: participantDetails.primaryName.concat(
											" ",
											participantDetails.secondaryName ? participantDetails.secondaryName : ""
										),
									})
								: I18n.t(score >= 50 ? "quiz.finished.score.good" : "quiz.finished.score.bad")}
						</span>{" "}
						<Colored>{I18n.t("quiz.finished.score.value", { score: Math.floor(score) })}</Colored>
					</span>
				</ScoreDescription>
				{!!quiz.participants.meanScore && (
					<Primary>
						<span>
							{I18n.t("quiz.finished.score.infos")}{" "}
							<b>{I18n.t("quiz.finished.score.average", { score: Math.floor(quiz.participants.meanScore) })}</b>
						</span>
					</Primary>
				)}
				{!isAuthor && (
					<LoadingButton onClick={run} loading={loading}>
						{I18n.t("quiz.finished.share")}
					</LoadingButton>
				)}
			</Stack>
		</Container>
	);
};

const Container = styled.div`
	${stack(40)};
`;

const ScoreDescription = styled(Title)`
	font-size: 1.875rem;
`;
const Colored = styled.span`
	color: ${({ theme }) => theme.colors.primary};
`;
